import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import CatalogProducts from './products';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.user != this.props.user) {
            return true;
        }

        return false;
    }

    render({ mode }) {
        return (
            <catalog-content mode={mode}>
                <h1 className={mode && mode == 'journal' ? 'has-margin-25' : ''}>Readings & Reports</h1>
                {this.renderSubheader()}
                <CatalogProducts mode={mode} />
            </catalog-content>
        );
    }

    renderSubheader = () => {
        if (!this.props.mode || this.props.mode != 'journal') {
            if (this.props.user.logged_in) {
                const total_kcs = this.props.user.kcs.total.toLocaleString();
                return (
                    <p>
                        {this.props.user.username}, you have <a href='/store/karma-coins'>{total_kcs} KARMA COINS</a>
                        &nbsp;to use towards your purchase.<br />Browse our products below or&nbsp;
                        <a href='/store/karma-coins'>GET MORE KARMA COINS</a>.
                    </p>
                );
            }

            return (<p>Choose from our authentic collection of readings and reports to get the insight you need.</p>);
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps)(Component);
